<template>
  <aside
    class="overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs"
    :class="`${
      'fixed-start '
    }
    ${
      this.$store.state.layout === 'landing'
        ? 'bg-transparent shadow-none'
        : ' '
    } ${this.$store.state.sidebarType}`"
    id="sidenav-main"
    style="background-color: #E5E4E3!important;"
  >
    <div class="sidenav-header">
      <!-- 모바일 닫기 버튼 -->
      <button
        class="sidenav-close-btn"
        @click="closeMobileSidenav"
        aria-label="메뉴 닫기"
      >
        <i class="fas fa-times"></i>
      </button>
      <router-link
        class="m-0 navbar-brand"
        to="/dashboard"
        @click="handleNavClick"
        style="background-color: #fff !important; display:flex;"
      >
        <div style="width:32px; height: 32px;"/>
        <img
          :src="logo"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
      </router-link>
    </div>
    <sidenav-list :cardBg="custom_class" @nav-click="handleNavClick" />
  </aside>
</template>
<script>
import SidenavList from "@/views/components/Sidenav/SidenavList.vue";
import logoWhite from "@/assets/img/AppIcon+Logotype.svg";
import { mapMutations, mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  props: ["custom_class", "layout"],
  data() {
    return {
      logo: '',
      logoWhite,
    };
  },
  computed: {
    ...mapState(['isMobileView']),
  },
  watch: {
    // 라우트 변경 시 모바일에서 사이드바 자동 닫기
    '$route'() {
      if (this.isMobileView) {
        this.closeMobileSidenav();
      }
    },
  },
  methods: {
    ...mapMutations(['closeMobileSidenav']),
    handleNavClick() {
      // 모바일에서 메뉴 클릭 시 사이드바 닫기
      if (this.isMobileView) {
        this.closeMobileSidenav();
      }
    },
  },
  mounted() {
    if(localStorage.getItem('userImageUrlCerti')) {
      this.logo = localStorage.getItem('userImageUrlCerti');
    }
  },
};
</script>
<style>
aside::-webkit-scrollbar {
  display: none;
}

/* 모바일 닫기 버튼 - 기본적으로 숨김 */
.sidenav-close-btn {
  display: none;
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

.sidenav-close-btn:hover {
  background: rgba(0, 0, 0, 0.2);
}

.sidenav-close-btn i {
  font-size: 16px;
  color: #333;
}

/* 모바일에서 닫기 버튼 표시 */
@media screen and (max-width: 767px) {
  .sidenav-close-btn {
    display: flex;
  }

  .sidenav-header {
    position: relative;
  }
}
</style>
